import {svgIconWrapper} from '../svg-icon-wrapper';

import MessengerRegular from './messenger-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <MessengerRegular {...props} />;
}

SvgComponent.iconName = 'messengerRegular';

export const MessengerRegularIcon = svgIconWrapper(SvgComponent);
